<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Bank  Branks</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                    <button class="btn btn-success" @click="newBankBranch()">Add New</button>
                    <vue-excel-xlsx
                        :data="bank_branch_mastersExcel"
                        :columns="columns"
                        :filename="'BankBranchData'"
                        :sheetname="'sheetname'"
                        class="btn btn-success"
                        >
                        Excel
                    </vue-excel-xlsx>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Branch Name</th>
                            <th>Bank Name</th>
                            <th>Branch Email</th>
                            <th>Branch Code</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(bank_master,i) in bank_branch_masters.data" :key="bank_master.BANK_BRANCH_ID">
                            <td>{{ i+1 }}</td>
                            <td> {{ bank_master.Bank_Branch_Name}} </td>
                            <td> {{ bank_master.Bank_Name}} </td>
                            <td> {{ bank_master.Bank_Branch_Email}} </td>
                            <td> {{ bank_master.Bank_Branch_Code}} </td>
                            <td>
                                <a href="#" @click="editBankBranch(bank_master)"><i class="fas fa-edit"></i></a>/
                                <a href="#" @click="deleteBankBranch(bank_master.BANK_BRANCH_ID)"><i class="fas fa-trash-alt red"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="bank_branch_masters" @pagination-change-page="loadAndSearchBankBranch" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchBankBranch(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
                <!-- Modal -->
            <div class="modal fade" id="bank_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode" id="exampleModalLabel">Add New Bank</h5>
                    <h5 class="modal-title" v-show="editmode" id="exampleModalLabel">Update Bank</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="editmode ? UpdateBank() : CreateBankBranchMaster()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                    <div class="form-group">
                            <label>Bank Name</label>
                            <multiselect
                                    v-model="form.BANK_ID_REF"
                                    :options="bank_master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    label="Bank_Name"
                                    track-by="BANK_ID"
                                    aria-required="true">
                            </multiselect>
                            <has-error :form="form" field="Bank_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Bank Branch Name</label>
                            <input v-model="form.Bank_Branch_Name" type="text" name="Bank_Branch_Name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Bank_Branch_Name') }">
                            <has-error :form="form" field="Bank_Branch_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Bank Branch Email</label>
                            <input v-model="form.Bank_Branch_Email" type="text" name="Bank_Branch_Email"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Bank_Branch_Email') }">
                            <has-error :form="form" field="Bank_Branch_Email"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Bank Branch Code</label>
                            <input v-model="form.Bank_Branch_Code" type="text" name="Bank_Branch_Code"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Bank_Branch_Code') }">
                            <has-error :form="form" field="Bank_Branch_Code"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" v-show="!editmode" class="btn btn-primary">Save Bank</button>
                    <button type="submit" v-show="editmode" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                editmode:false,
                search:'',
                bank_branch_masters:{},
                bank_master:[],
                bank_branch_mastersExcel:[],
                form: new Form({
                    BANK_ID:'',
                    BANK_BRANCH_ID:'',
                    Bank_Branch_Name:'',
                    Bank_Branch_Email:'',
                    Bank_Branch_Code:'',
                    BANK_ID_REF:'',
                    Bank_Name:''
                }),
                columns : [
                    {
                        label: "Bank Name",
                        field: "Bank_Name",
                    },
                    {
                        label: "Bank Branch Name",
                        field: "Bank_Branch_Name",
                    },
                    {
                        label: "Bank Branch Code",
                        field: "Bank_Branch_Code",
                    },
                    {
                        label: "Bank Branch Email",
                        field: "Bank_Branch_Email",
                    },
                    {
                        label: "Bank Branch Is Active",
                        field: "Bank_Branch_Is_Active",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchBankBranch();
            })
            Fire.$on('AfterChangeBank',()=>{
                this.loadAndSearchBankBranch();
            });
        },
        mounted(){
            this.loadBank();
            this.loadAndSearchBankBranch();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            UpdateBank(){
                this.toast.$emit("LoadingOn");
                this.form.put('bankBranch/'+this.form.BANK_BRANCH_ID)

                .then(()=> {
                    Fire.$emit('AfterChangeBank');
                    $('#bank_model').modal('hide');
                    this.toast.$emit('LoadingOffSuccess', "Bank Branch Updated successfully");
                })
                .catch(()=> {
                    this.toast.$emit('LoadingOffError', "your request could not be processed.");
                })
            },
            loadBank(){
                axios.get('/loadBank')
                .then(({data})=> {this.bank_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            editBankBranch(bank_master){
                this.editmode = true,
                this.form.reset();
                $('#bank_model').modal('show');
                this.form.fill(bank_master);
                console.log(bank_master)
                this.form.BANK_ID_REF = {"BANK_ID":this.form.BANK_ID_REF,"Bank_Name":this.form.Bank_Name};
            },
            newBankBranch(){
                this.editmode = false,
                this.form.reset();
                $('#bank_model').modal('show');
            },
            deleteBankBranch(BANK_ID){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            this.form.delete('bankBranch/'+BANK_ID).then(()=>{
                            Fire.$emit('AfterChangeBank');
                            this.toast.$emit('SwalSuccess',"Deleted!", "Bank Branch Deleted.");

                        }).catch(()=>{
                            this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Bank Branch Is Already In Use");
                        })
                        }
                    })
            },
            CreateBankBranchMaster(){
                this.toast.$emit("LoadingOn");
                this.form.post('bankBranch')
                .then(()=>{
                    $('#bank_model').modal('hide')
                    // this.loadAndSearchBankBranch();
                    Fire.$emit('AfterChangeBank');
                    this.toast.$emit('LoadingOffSuccess', "Bank Branch Create successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            loadAndSearchBankBranch(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchBankBranch?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.bank_branch_masters = data,
                        this.toast.$emit('ProgressBarFinish'),
                        this.loadAndSearchBankBranchExcel()
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
            loadAndSearchBankBranchExcel(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchBankBranchExcel?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.bank_branch_mastersExcel = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
